import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { userService } from "../_services/user.service";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (rest.shouldRenew && userService.shouldRenewToken()) {
        userService.renewToken();
      }
      return sessionStorage.getItem("user") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/LogInMain", state: { from: props.location } }}
        />
      );
    }}
  />
);

const mapStateToProps = (state, ownProps) => {
  return {
    loggedIn: state.authentication.loggedIn,
    error: state.authentication.error,
    shouldRenew:
      ownProps.shouldRenew === undefined ? true : ownProps.shouldRenew,
  };
};
PrivateRoute.propTypes = {
  shouldRenew: PropTypes.bool,
};
const connectedPR = connect(mapStateToProps)(PrivateRoute);
export { connectedPR as PrivateRoute };

connectedPR.defaultProps = {
  shouldRenew: true,
};

/*
const PrivateRouteComponent = (props) => (
    <Route {...props.routeProps} render={() => (
        props.logged_in ? (
            <div>{props.children}</div>
        ) : (
                <Redirect to={{
                    pathname: '/login',
                    state: { from: props.location }
                }} />)
    )} />
);

const mapStateToProps = (state, ownProps) => {
    return {
        logged_in: state.auth.logged_in,
        location: ownProps.path,
        routeProps: {
            exact: ownProps.exact,
            path: ownProps.path
        }
    };
};

const PrivateRoute = connect(mapStateToProps, null)(PrivateRouteComponent);
export default PrivateRoute
*/
